// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"92be2a8d","442":"63175cef","636":"5df57724","637":"31c9a49c","704":"219f7958","765":"47af6854","787":"30ae3ceb","920":"81659d1b","975":"79106a90"}[chunkId] + ".chunk.js";
};